import { supabase } from '../auth/supabaseClient'

export type ProfileRow = {
  user_id: string
  first_name: string
  last_name: string
  nickname: string | null
  country_code: string | null
  region: string | null
  postal_code: string | null
  age: number | null
  gender: 'M' | 'F' | 'N'
  daily_goal_reps: number | null
  weekly_goal_reps: number | null
  public_opt_in?: boolean | null
}

export async function getProfile(): Promise<ProfileRow | null> {
  try {
    const { data: auth } = await supabase.auth.getSession()
    const userId = auth.session?.user?.id
    if (!userId) return null
    const { data, error } = await supabase.from('profiles').select('*').eq('user_id', userId).maybeSingle()
    if (error) return null
    return data as ProfileRow
  } catch {
    return null
  }
}

export type ProfilePatch = Partial<Pick<ProfileRow, 'age' | 'gender' | 'region' | 'postal_code' | 'nickname' | 'daily_goal_reps' | 'public_opt_in'>>

export async function updateProfile(patch: ProfilePatch): Promise<boolean> {
  try {
    const { data: auth } = await supabase.auth.getSession()
    const userId = auth.session?.user?.id
    if (!userId) return false
    const { error } = await supabase.from('profiles').update({ ...patch, updated_at: new Date().toISOString() }).eq('user_id', userId)
    if (error) return false
    return true
  } catch {
    return false
  }
}

// Helpers to map between age ranges and approximate numeric age for DB storage
export const ageRanges = [
  '<18', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'
]

export function rangeToAge(range: string): number | null {
  switch (range) {
    case '<18': return 16
    case '18-24': return 21
    case '25-34': return 30
    case '35-44': return 40
    case '45-54': return 50
    case '55-64': return 60
    case '65+': return 70
    default: return null
  }
}

export function ageToRange(age: number | null | undefined): string {
  if (!age && age !== 0) return ''
  if (age < 18) return '<18'
  if (age <= 24) return '18-24'
  if (age <= 34) return '25-34'
  if (age <= 44) return '35-44'
  if (age <= 54) return '45-54'
  if (age <= 64) return '55-64'
  return '65+'
}
